/* Ancient Bliss — full-page Build-a-Bundle engine (standalone /pages/build-your-bundle).
   Same tier logic as ab-bundle.js, plus a live side-cart: item rows with steppers,
   tier rail checkpoints, and a mobile collapse. Tier % is a DISPLAY estimate; the real
   discount is the matching Shopify automatic discounts (15% @3, 20% @4, 25% @5). */
class ABBundleBuilder extends HTMLElement {
  connectedCallback() {
    this.tiers = JSON.parse(this.dataset.tiers || '[]').sort(function (a, b) { return b.min - a.min; });
    this.asc = this.tiers.slice().sort(function (a, b) { return a.min - b.min; });
    this.sel = new Map(); // variantId -> { qty, price, title, img }
    this.cards = new Map();
    var self = this;
    this.querySelectorAll('[data-variant-id]').forEach(function (card) {
      var id = card.dataset.variantId;
      self.cards.set(id, card);
      var add = card.querySelector('[data-add]');
      var inc = card.querySelector('[data-inc]');
      var dec = card.querySelector('[data-dec]');
      if (add) add.addEventListener('click', function () { self.setQty(id, self.qty(id) + 1); });
      if (inc) inc.addEventListener('click', function () { self.setQty(id, self.qty(id) + 1); });
      if (dec) dec.addEventListener('click', function () { self.setQty(id, self.qty(id) - 1); });
    });
    this.cta = this.querySelector('[data-bundle-add]');
    if (this.cta) this.cta.addEventListener('click', function () { self.addToCart(); });
    var head = this.querySelector('[data-cart-toggle]');
    if (head) head.addEventListener('click', function () {
      if (window.matchMedia('(max-width: 899px)').matches) self.classList.toggle('is-cart-open');
    });
    this.render();
  }
  qty(id) { return this.sel.get(id) ? this.sel.get(id).qty : 0; }
  setQty(id, qty) {
    var card = this.cards.get(id);
    if (!card) return;
    if (qty <= 0) this.sel.delete(id);
    else this.sel.set(id, { qty: qty, price: parseInt(card.dataset.price, 10) || 0, title: card.dataset.title || '', img: card.dataset.img || '' });
    var q = this.qty(id);
    var add = card.querySelector('[data-add]');
    var step = card.querySelector('[data-stepper]');
    if (add) add.style.display = q > 0 ? 'none' : '';
    if (step) { step.style.display = q > 0 ? 'flex' : 'none'; var s = step.querySelector('[data-qty]'); if (s) s.textContent = q; }
    card.classList.toggle('is-picked', q > 0);
    this.render();
  }
  money(c) { return '$' + (c / 100).toFixed(2); }
  setText(sel, val) { this.querySelectorAll(sel).forEach(function (el) { el.textContent = val; }); }
  render() {
    var self = this;
    var count = 0, subtotal = 0;
    this.sel.forEach(function (v) { count += v.qty; subtotal += v.price * v.qty; });
    var tier = this.tiers.find(function (t) { return count >= t.min; }) || null;
    var pct = tier ? tier.pct : 0;
    var savings = Math.round((subtotal * pct) / 100);
    var total = subtotal - savings;
    // Markers sit at evenly spaced centres (space-around => (i + 0.5) / n). Interpolate the
    // fill between those centres so it reaches a dot exactly as that tier unlocks.
    var fill = this.querySelector('[data-rail-fill]');
    if (fill) {
      var n = this.asc.length;
      var pos = function (i) { return ((i + 0.5) / n) * 100; };
      var w = 0;
      if (n) {
        var idx = -1;
        for (var i = 0; i < n; i++) { if (count >= this.asc[i].min) idx = i; }
        if (idx === n - 1) {
          w = 100;                                   // top tier hit, bar reads as maxed out
        } else if (idx < 0) {
          var firstMin = this.asc[0].min || 1;
          w = (count / firstMin) * pos(0);           // ramping up to the first tier
        } else {
          var a = this.asc[idx], b = this.asc[idx + 1];
          var span = (b.min - a.min) || 1;
          w = pos(idx) + ((count - a.min) / span) * (pos(idx + 1) - pos(idx));
        }
      }
      fill.style.width = Math.max(0, Math.min(100, w)) + '%';
    }
    this.querySelectorAll('[data-mark-min]').forEach(function (m) {
      m.classList.toggle('is-hit', count >= parseInt(m.dataset.markMin, 10));
    });
    this.setText('[data-count]', count + (count === 1 ? ' item' : ' items'));
    var next = this.asc.find(function (t) { return count < t.min; }) || null;
    this.setText('[data-tier-msg]', next
      ? 'Add ' + (next.min - count) + ' more to ' + (tier ? 'reach ' : 'unlock ') + next.pct + '% off'
      : (tier ? 'You’re saving ' + pct + '%, max unlocked!' : 'Add 3 to start saving'));
    // Side-cart rows + dashed teaser slots for the tiers still locked
    var list = this.querySelector('[data-items]');
    if (list) {
      var html = '';
      this.sel.forEach(function (v, id) {
        html += '<div class="ab-bbp-row" data-row-id="' + id + '">'
          + (v.img ? '<img src="' + v.img + '" alt="" width="44" height="44" loading="lazy">' : '<span class="ab-bbp-row-ph"></span>')
          + '<div class="ab-bbp-row-mid"><div class="ab-bbp-row-title">' + v.title + '</div>'
          + '<div class="ab-bbp-row-step"><button type="button" data-row-dec aria-label="Decrease quantity">−</button><span>' + v.qty + '</span><button type="button" data-row-inc aria-label="Increase quantity">+</button></div></div>'
          + '<div class="ab-bbp-row-price">' + self.money(v.price * v.qty) + '</div></div>';
      });
      for (var i = this.sel.size; i < 3; i++) {
        var t = this.asc[Math.min(i, this.asc.length - 1)];
        var hint = (i === 0 && this.sel.size === 0) ? 'Pick your first formula' : (t ? 'Add ' + t.min + ' items, unlock ' + t.pct + '%' : '');
        html += '<div class="ab-bbp-slot"><span class="ab-bbp-slot-plus">+</span><div><div class="ab-bbp-slot-t">Select a product</div>' + (hint ? '<div class="ab-bbp-slot-s">' + hint + '</div>' : '') + '</div></div>';
      }
      list.innerHTML = html;
      list.querySelectorAll('.ab-bbp-row').forEach(function (row) {
        var id = row.dataset.rowId;
        var inc = row.querySelector('[data-row-inc]');
        var dec = row.querySelector('[data-row-dec]');
        if (inc) inc.addEventListener('click', function () { self.setQty(id, self.qty(id) + 1); });
        if (dec) dec.addEventListener('click', function () { self.setQty(id, self.qty(id) - 1); });
      });
    }
    this.setText('[data-subtotal]', this.money(subtotal));
    this.setText('[data-savings]', savings ? '−' + this.money(savings) : this.money(0));
    this.setText('[data-discount-label]', pct ? 'Discount (' + pct + '%)' : 'Discount');
    this.setText('[data-total]', this.money(total));
    if (this.cta) {
      this.cta.disabled = count === 0;
      this.cta.textContent = count === 0 ? 'Add products to begin' : 'Add ' + count + ' to cart · ' + this.money(total);
    }
    var err = this.querySelector('[data-cart-err]');
    if (err) err.hidden = true;
  }
  addToCart() {
    var self = this;
    var items = [];
    this.sel.forEach(function (v, id) { items.push({ id: Number(id), quantity: v.qty }); });
    if (!items.length) return;
    this.cta.disabled = true;
    this.cta.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) {
        if (!r.ok) return r.json().catch(function () { return null; }).then(function (d) {
          throw new Error((d && (d.description || d.message)) || 'Could not add to cart, please try again.');
        });
        window.location.href = '/cart';
      })
      .catch(function (e) {
        self.render();
        var err = self.querySelector('[data-cart-err]');
        if (err) { err.textContent = e.message; err.hidden = false; }
      });
  }
}
customElements.define('ab-bundle-builder', ABBundleBuilder);
